import React from 'react';
import Link from 'gatsby-link';
import { SocialIcons } from 'react-social-icons';

import Box from '../components/box';
import Project from '../components/project';

import profile from './profile.jpg';
import mux from '../projects/mux.svg';
import youtube from '../projects/youtube.png';
import logwhale from '../projects/logwhale.svg';
import gogocal from '../projects/gogocal.png';

const IndexPage = () => {
  let urls = [
    'https://github.com/therealwardo',
    'https://www.linkedin.com/in/therealwardo',
    'https://twitter.com/therealwardo',
    'https://www.instagram.com/therealwardo',
    'https://facebook.com/matt.wardo',
    'https://plus.google.com/+MattWardo',
  ];
  return (
    <div className='main'>
      <Box color={2} className='profile'>
        <img src={profile} className='profile' />
        <SocialIcons urls={urls} color='black' />
      </Box>
      <Box large={true} className='info'>
        <p>oh hai there. I <span>design and build</span> virtual and physical things. I work most days building video for the internet at <a href='https://mux.com' target='_blank'>Mux</a>. once upon a time I worked at YouTube, freelanced from the mountains of Colorado, and studied at Columbia University in New York City.</p>
      </Box>
      <Box giant={true} color={3} className='blurb'>
        <p style={{textAlign: 'center'}}>this is some stuff I made...</p>
        <p style={{textAlign: 'center', fontSize: '14px'}}>(in kinda sorta chronological order)</p>
      </Box>
      <Box giant={true} color={4} className='project'>
        <Project img={mux}>
          <h3><a href='https://mux.com' target='_blank'>Mux</a></h3>
          <p>Working with an amazing team on Mux Video and Data since 2016. We started by helping publishers <a href='https://mux.com/data/' target='_blank'>understand their viewer's experience</a> and we are now working on making it easier for anyone to become an online video publisher.</p>
        </Project>
      </Box>
      <Box giant={true} color={4} className='project'>
        <Project img={logwhale} flip={true}>
          <h3><a href='http://logwhale.com' target='_blank'>LogWhale</a></h3>
          <p>An <a href='https://github.com/therealwardo/logwhale' target='_blank'>open source Kibana plugin</a> for tailing logs from containers. Built because tailing logs across all the pods in a Kubernetes cluster shouldn't be that hard, but it was.</p>
        </Project>
      </Box>
      <Box giant={true} color={4} className='project'>
        <Project img={gogocal}>
          <h3><a href='https://www.gogocal.com' target='_blank'>GogoCAL</a></h3>
          <p>a professional calendar application used by creative industry professionals to make booking and managing events easier.</p>
        </Project>
      </Box>
      <Box giant={true} color={4} className='project'>
        <Project img={youtube} flip={true}>
          <h3><a href='https://www.youtube.com' target='_blank'>YouTube</a></h3>
          <p>Started writing the Flash video player. Worked on video infrastructure to help ease the transition to HTML5 video, and then ended up leading the backend API for the video players as well as a larger frontend focused API infrastructure effort.</p>
        </Project>
      </Box>
      <Box giant={true} color={3} className='final'>
        <p style={{textAlign: 'center'}}>I did other stuff too.</p>
        <p style={{textAlign: 'center', fontSize: '14px'}}>(I just haven't gotten around to putting it in here yet)</p>
      </Box>
    </div>);
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js